import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';

export const CurrentColorUnit = styled.div`
  ${typography.xs.regular};
  color: ${globalTheme.palette.secondaryAlt};
  text-align: center;
  margin-top: ${globalTheme.spacing.xxs};
  text-transform: capitalize;
`;
